<template>
	<div class="w1200 flex flex-direction align-stretch benben-flex-layout bind" v-loading="loading"  :element-loading-text="$t('拼命加载中')">
	    <div class="flex bind_1">
	    	<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
	    		<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
	    		<div class="bind_1_2">{{$t('返回')}}</div>
	    	</div>
	    </div>
		<div class="flex benben-flex-layout flex-wrap align-center">
			<div class="mealTicket_1">{{$t('我的饭票')}}</div>
			<div class="flex mealTicket_2">
				<div class="mealTicket_2_1 pointer" @click="caozuo(2)">{{$t('饭票明细')}}</div>
				<div class="mealTicket_2_2 pointer" @click="caozuo(3)">{{$t('充值')}}</div>
			</div>
		</div>
		<div class="mealTicket_3">{{$t('个人饭票')}}</div>
		<div class="flex wrap">
			<div class="mealTicket_4 flex flex-direction flex-wrap align-center justify-center benben-flex-layout">
				<div class="mealTicket_4_1">{{details.meal_ticket_two}}{{$t('张')}}</div>
				<div class="mealTicket_4_2">{{$t('2菜饭票')}}</div>
			</div>
			<div class="mealTicket_4 flex flex-direction flex-wrap align-center justify-center benben-flex-layout">
				<div class="mealTicket_4_1">{{details.meal_ticket_three}}{{$t('张')}}</div>
				<div class="mealTicket_4_2">{{$t('3菜饭票')}}</div>
			</div>
		</div>
		<div class="mealTicket_3">{{$t('朋友饭票')}}</div>
		<div class="flex wrap">
			<div class="mealTicket_4 flex flex-direction flex-wrap align-center justify-center benben-flex-layout">
				<div class="mealTicket_4_1">{{details.meal_ticket_two_friend}}{{$t('张')}}</div>
				<div class="mealTicket_4_2">{{$t('2菜饭票')}}</div>
			</div>
			<div class="mealTicket_4 flex flex-direction flex-wrap align-center justify-center benben-flex-layout">
				<div class="mealTicket_4_1">{{details.meal_ticket_three_friend}}{{$t('张')}}</div>
				<div class="mealTicket_4_2">{{$t('3菜饭票')}}</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				loading:true,
				details:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68d3bf9d40c03()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68d3bf9d40c03()
			},
			// 获取会员饭票资产
			post68d3bf9d40c03(){
				this.$api.post(this.$apiUrls.post68d3bf9d40c03).then((res) => {
					if(res.code == 1){
						this.details = res.data
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type){
				let url = ''
				if(type == 1){
					// url = 'myinfo'
					window.history.back();
					return
				}else if(type == 2){
					url = 'meaList'
				}else if(type == 3){
					url = 'topUp'
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.bind{
		margin-top: 20px;
		padding: 0 20px 100px;
		background: #fff;
	}
	.bind_1{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
	.mealTicket_1{
		font-weight: 500;
		font-size: 16px;
		color: #1A1A1A;
	}
	.mealTicket_2{
		margin: 20px 0 0 auto;
	}
	.mealTicket_2_1{
		height: 36px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF8A24;
		font-weight: 400;
		font-size: 14px;
		color: #FF8A24;
		line-height: 36px;
		padding: 0 22px;
	}
	.mealTicket_2_2{
		height: 36px;
		background: #FF770F;
		border-radius: 4px 4px 4px 4px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 36px;
		padding: 0 22px;
		margin: 0 0 0 20px;
	}
	.mealTicket_3{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 20px 0 0 0;
	}
	.mealTicket_4{
		width: 200px;
		height: 96px;
		background: #F6F7F9;
		border-radius: 8px 8px 8px 8px;
		margin: 16px 16px 0 0;
	}
	.mealTicket_4_1{
		font-weight: bold;
		font-size: 18px;
		color: #1A1A1A;
	}
	.mealTicket_4_2{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
		margin: 10px 0 0 0;
	}
</style>